// GENERATED FILE -- do not edit by hand.
// Regenerate with `npm run codegen:stores` (see frontend/package.json).
// Source: agent.app.sandbox_session.SandboxSession

import { makeObservable, observable } from "mobx";
import { applyJsonPatch, JsonPatchOp } from "@/app_store/rpc/json_patch";
import { AgentTransport, callRpc } from "@/app_store/rpc/rpc";
import { registerEntity, wrapEntity } from "@/app_store/rpc/entity";
import { DirectoryEntryData, DirectoryEntryStore } from "./DirectoryEntry.generated";

export interface SandboxSessionData {
    // Stamped onto every @observable model's dump at runtime (see
    // common._ObservableMixin._serialize_with_tag) -- tells wrapEntity which
    // generated Store class this value belongs to. Never sent by a client.
    _entity_class_name: "SandboxSession";
    id: string;
    directories: Record<string, DirectoryEntryData>;
    files: Record<string, string>;
}

export class SandboxSessionStore {
    readonly _entity_class_name = "SandboxSession" as const;
    id: string;
    directories: Record<string, DirectoryEntryStore>;
    files: Record<string, string>;
    private _transport: AgentTransport;
    private _chainPath: string[];

    constructor(data: SandboxSessionData, transport: AgentTransport, chainPath: string[] = []) {
        this._transport = transport;
        this._chainPath = chainPath;
        this.id = wrapEntity(data.id, transport, [...chainPath, "id"]);
        this.directories = Object.fromEntries(
            Object.entries(data.directories ?? {}).map(([key, val]) => [
                key, wrapEntity(val, transport, [...chainPath, "directories", key]),
            ])
        ) as Record<string, DirectoryEntryStore>;
        this.files = wrapEntity(data.files, transport, [...chainPath, "files"]);
        makeObservable(this, {
            id: observable,
            directories: observable,
            files: observable,
        });
    }

    applyPatch(op: JsonPatchOp): void {
        applyJsonPatch(this, op);
    }

    async read_file(path: string): Promise<any> {
        return callRpc(this._transport, this._chainPath, "read_file", [path], {});
    }

    async write_file(path: string, content: string): Promise<any> {
        return callRpc(this._transport, this._chainPath, "write_file", [path, content], {});
    }

    async remove_file(path: string): Promise<any> {
        return callRpc(this._transport, this._chainPath, "remove_file", [path], {});
    }

    async list_dir(rel_path?: string): Promise<any> {
        return callRpc(this._transport, this._chainPath, "list_dir", [rel_path], {});
    }

    async list_all_files(rel_dir?: string, depth?: number): Promise<any> {
        return callRpc(this._transport, this._chainPath, "list_all_files", [rel_dir], {depth: depth});
    }

    async watch_directories(paths: string[], recursive?: boolean): Promise<any> {
        return callRpc(this._transport, this._chainPath, "watch_directories", [paths], {recursive: recursive});
    }

    async watch_files(paths: string[]): Promise<any> {
        return callRpc(this._transport, this._chainPath, "watch_files", [paths], {});
    }
}

registerEntity("SandboxSession", SandboxSessionStore);
